module.exports = __webpack_public_path__ + "img/emission-badge-2025.82ea2aaf.png";